import React from 'react';
import type { Report } from './types';

interface ReportRowProps {
  report: Report;
  onView: (report: Report) => void;
  isLoading?: boolean;
}

export const ReportRow = React.memo(function ReportRow({ report, onView, isLoading }: ReportRowProps) {
  const formattedDate = new Date(report.created_timestamp).toLocaleString('en-GB', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
    hour12: false,
  });

  return (
    <li className="flex w-full items-center px-4 py-3 text-gray-100 gap-4 border-b border-white/5 last:border-b-0 hover:bg-white/[0.04] transition-colors">
      <div className="w-16 shrink-0 flex items-center justify-center">
        <div className="w-2.5 h-2.5 rounded-full bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.5)]" />
      </div>
      <time className="w-36 shrink-0 text-sm text-gray-300" dateTime={report.created_timestamp}>
        {formattedDate} UTC
      </time>
      <div className="flex-1 min-w-0">
        <div className="text-sm text-white truncate">{report.vessel_name || 'Unknown Vessel'}</div>
      </div>
      <button
        type="button"
        onClick={() => onView(report)}
        disabled={isLoading}
        className="w-20 shrink-0 px-3 py-1.5 text-xs font-medium text-blue-400 bg-blue-500/10 border border-blue-500/30 rounded-md hover:bg-blue-500/20 hover:border-blue-400/50 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? 'Loading...' : 'View'}
      </button>
    </li>
  );
});
